import { z } from 'zod';
import { trancheModelSchema } from './tranche.schema';

export const enrollmentCardHolderTypeSchema = z.enum([
  'primary',
  'supplementary',
]);

export const pointsAccountModelSchema = z.object({
  id: z.string(),
  type: z.literal('points_account'),
  attributes: z.object({
    id: z.string(),
    referenceId: z.string(),
    status: z.string(),
    pointsBalance: z.number(),
    enrollments: z.array(
      z.object({
        id: z.string(),
        cardholderType: enrollmentCardHolderTypeSchema.nullable(),
        productRank: z.number(),
        productCode: z.string(),
        groupReferenceId: z.string(),
        groupName: z.string(),
      }),
    ),
    tranches: z.array(trancheModelSchema),
  }),
});

export const pointsAccountResponseSchema = z.object({
  data: z.array(pointsAccountModelSchema),
});
